import { useState, useEffect } from "react";
import { Research } from "../types";
import { deepResearchApi } from "../api";
import { useAlert } from "../../../context/AlertContext";
import { useTranslation } from "react-i18next";

export const useResearchList = () => {
  const { setAlert } = useAlert();
  const { t } = useTranslation();
  const [researches, setResearches] = useState<Research[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [statusFilter, setStatusFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const loadResearches = async () => {
    setLoading(true);
    try {
      const response = await deepResearchApi.getResearchList({
        page,
        page_size: 12,
        status: statusFilter || undefined,
      });
      setResearches(response.data.results);
      setTotalPages(Math.ceil(response.data.count / 12));
    } catch {
      setAlert("error", t("deepResearch.errors.loadFailed"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadResearches();
  }, [page, statusFilter]);

  const filteredResearches = researches.filter(
    (research) =>
      research.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      research.query.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return {
    researches: filteredResearches,
    loading,
    page,
    setPage,
    totalPages,
    statusFilter,
    setStatusFilter,
    searchQuery,
    setSearchQuery,
    loadResearches,
  };
};
